import { message, notification, Modal, Button, Spin } from 'antd';
import React from 'react';
import { bindActionCreators } from 'redux'
import axios from 'axios'

import { wxSmallProgramRequestAction, serviceRequestPiccActions, report, reportPreviewActions } from './lossAss/actions'
import { serviceRequestActions, uploadAction } from './actions';
import { LeaveMsg } from './lossAss/components'
import { isIosDevice } from './utils/device'
import { endSession } from './utils/session'
import { removeUserAccessToken, removeKandyUAT, removeKandyUserName, removeKandyPassword } from './utils/auth'
import EventBus from './components/eventBus.js';
import UploadList from './components/UploadList/index.jsx'


const { socketEnv, socketUrl = '/' } = process.env || {};

let socketOption = {
    transports: socketEnv === "development" ? ['polling'] : ['websocket'],
    reconnectionDelay: 5000 + parseInt(Math.random() * 20000),
    reconnectionDelayMax: 25000
}
let socket = null
var _agentFullId, _companyId
let isDisconnected = false
let startTime = 0, faildTime = 0, successTime = 0, registTime = 0


let removeNotificationListener = () => {
    socket.off('serviceRequestsUpdated')
}

let messageEvent = (companyId, serviceRequestId, customerId, customerEmail, sender, receiver, message) => {
    socket.emit('messageEvent', { companyId, serviceRequestId, customerId, customerEmail, sender, receiver, message })
}




/********************** agent start ***********************/

let agentKandyStatus = (dispatch, fullUserId, kandyStatus, actions) => {
    socket.emit('agentKandyStatus', { fullUserId, kandyStatus })
    dispatch(actions.setAgentKandyStatus(kandyStatus))
}

let agentLoggedIn = (fullUserId, companyId) => {
    _agentFullId = fullUserId
    _companyId = companyId
    // Notify server when the user logs in
    if (!socket) socket = io(socketUrl, socketOption)
    if (isDisconnected) {
        socket.connect()
    }
    socket.emit('agentOnline', { fullUserId, companyId })
}

let agentLoggedOut = (fullUserId, companyId) => {
    socket.removeAllListeners()//删除所有注册事件
    // Notify server when the user logs out
    socket.emit('agentOffline', { fullUserId, companyId })
    //When agent logout, socket should not keep connection with server
    //The retry may cause reconnect to a new server process
    socket.disconnect()
    isDisconnected = true
    socket.off('connect')
}

let agentExpired = (dispatch, kandyActions, actions, getState) => {
    socket.on('agentExpired', fullUserId => {
        if (fullUserId === getState().app.currentAgent.userInfo.fullUserId) {
            removeUserAccessToken();
            removeKandyUAT();
            removeKandyUserName();
            removeKandyPassword();
            socket.removeAllListeners(); //删除所有注册事件
            socket.disconnect();
            isDisconnected = true;
            socket.off('connect');
            dispatch(kandyActions.logout());
            window.location.href = '/login';
        }
        else {
            dispatch(actions.updateAgentLoginState(fullUserId, false))
        }
    })
}

let agentUnload = () => {
    if (_agentFullId && _companyId) {
        socket.emit('agentUnload', { _agentFullId, _companyId })
    }
    socket.removeAllListeners(); //删除所有注册事件
    socket.disconnect();
    isDisconnected = true;
    socket.off('connect');
}

let agentReconnect = (dispatch, actions, fullUserId, companyId, getState) => {
    let currentAgent = getState().app.currentAgent.userInfo;
    socket.on('connect', () => {
        let kandyStatus = getState().app.currentAgent.kandyStatus
        let agentId = currentAgent._id
        _agentFullId = fullUserId
        _companyId = companyId
        isDisconnected = false
        dispatch(actions.updateCurrentAgentState(fullUserId, companyId, "1"))
        dispatch(actions.updateCurrentAgentLoginState(true))
        socket.emit('reconnect_socket', { fullUserId, companyId, kandyStatus, agentId })
    })
}

let agentConnected = (dispatch, currentCompanyId, actions) => {
    socket.on('agentConnected', fullUserId => {
        dispatch(actions.updateAgentLoginState(fullUserId, true))
        dispatch(actions.updateCurrentAgentLoginState(true))
    })
}

let agentDisconnected = (dispatch, currentCompanyId, actions) => {
    socket.on('agentDisconnected', data => {
        dispatch(actions.updateAgentLoginState(data.fullUserId, false))
    })
}

let agentReconnectFailed = (dispatch, actions, getState, fullUserId, companyId) => {
    socket.on('disconnect', () => {

        dispatch(actions.clearServiceRequests())
    })
}

let noticeUpdateLoginState = (dispatch, currentCompanyId, actions) => {
    socket.on('noticeUpdateLoginState', data => {
        dispatch(actions.updateAgentLoginState(data.fullUserId, data.online))
    })
}

let noticeUpdateServiceStatus = (dispatch, actions) => {
    socket.on('noticeUpdateServiceStatus', data => {
        dispatch(actions.updateAgentServiceStatus(data.agentId, data.service))
    })
}

/********************** agent end ***********************/







let serviceRequestsUpdated = (dispatch, currentCompanyId, actions, currentAgent) => {
    socket.on('serviceRequestsUpdated', data => {




        if (currentCompanyId === data.serviceRequest.companyId && currentAgent._id == data.serviceRequest.agent) {
            if (data.newRequest && data.serviceRequest.channelType !== 'wxSmallProgram') {
                // let loginOutRS = dispatch(kandyActions.loginOut());
                // ;
            }
            dispatch(actions.updateServiceRequests(data))
        }
    })
}

let clientEndedSession = (dispatch, currentCompanyId, actions, getState) => {
    socket.on('clientEndedSession', data => {
        let calls = getState().app.kandy.calls, serviceRequests = getState().app.serviceRequests.customers,
            customers = getState().app.customers.current;


        if (calls) {
            let call = calls.filter((v) => {
                return v.calleeFullUserId == data.userId || v.callerFullUserId == data.userId
            })[0]

            if (call && call.callId) {
                dispatch(actions.endCall(call.callId))
            }
        }

        //挂断小程序视频流 关闭流
        if (data.channelType == 'wxSmallProgram') {
            let customer = serviceRequests.filter(obj => obj._id === data.requestId)[0] ||
                customers.filter(obj => obj._id === data.requestId)[0]

            if (customer && customer._id) {
                if (data.subType == 'dropConnection') {
                    message.warning('对端小程序已挂断')
                }
                window.postMessage({ cmd: 'invoke', code: 'sendRemoveStreamToBackground()' }, '*')
                dispatch(serviceRequestPiccActions.endSessionByPicc(customer._id));
            }
        }

        if (data.channelType && data.channelType.indexOf('mcu') > -1) {

            let customer = serviceRequests.filter(obj => obj._id === data.requestId)[0] ||
                customers.filter(obj => obj._id === data.requestId)[0]
            if (customer && customer._id) {
                // getState().app.conference.conference.leave();
                dispatch(serviceRequestPiccActions.endSessionByPicc(customer._id));
            }
        }

        endSession(dispatch, currentCompanyId, actions, getState, data)
    })
}

let customerDisconnected = (dispatch, currentCompanyId, actions, getState) => {
    socket.on('customerDisconnected', data => {

        let customers = getState().app.customers
        if (isIosDevice(customers, data.userId)) {

            return
        }
        endSession(dispatch, currentCompanyId, actions, getState, data)

        // dispatch(actions.sendMessage(data.userId, "", { additionalData: { "type": "control", "session": "ended" } }))
        let calls = getState().app.kandy.calls;
        if (calls) {
            let call = calls.filter((v) => {
                return v.calleeFullUserId == data.userId || v.callerFullUserId == data.userId
            })[0]

            if (call && call.callId) {
                dispatch(actions.endCall(call.callId))
            }
        }
    })
}


let receiveUploadCarPic_Client = (dispatch, actions, currentAgentId) => {
    socket.on('receiveUploadCarPic', data => {
        if (data.agentId === currentAgentId) {
            dispatch(actions.uploadNotification(data))
            //message.info('上传图片成功')
        }

    })
}


let uploadShotPicFinish = (dispatch, reportPreviewActions, getState, agentId) => {
    socket.on('uploadShotPicFinish', data => {
        console.log('uploadShotPicFinish')
        const { reportPreview = {} } = getState().lossAss || {};
        const { currentPreviewReport = {} } = reportPreview;
        if (data.agentId === agentId) {
            if (currentPreviewReport.flowId === data.flowId) {
                    // 调用图片阅读接口
                    axios({
                        method: 'get',
                        url: '/api/lossAss/shotPics/agentView',
                        params: {
                            flowId: data.flowId,
                            agentId: agentId,
                        }
                    }).then(res => {
                        if (res.data.errCode !== 0) {
                            return message.error(res.data.errInfo)
                        }
                    }).catch(err => {
                        message.error(err.message || '请求/api/lossAss/shotPics/agentView失败')
                    })
            }
            // 视频中拍照更新图片列表
            window.postMessage({ security: true, eventName: 'refreshPicsClassify', flowId: data.flowId }, '*')
        }
    })
}



// 医疗理算指派通知
const assignedAdjustReport = (dispatch, getState, report) => {
    socket.on('assignedAdjustReport', data => {
        const { subReportId, lossName, flowId, agent } = data;
        const userInfo = getState().app.currentAgent.userInfo;
        if (agent == (userInfo && userInfo._id)) {
            const timeStamp = new Date().getTime();
            notification['info']({
                message: '新增理算任务通知！',
                description: (
                    <div>
                        <span style={{ display: 'block' }}>您有新的理算任务生成，请及时处理，</span>
                        <span style={{ display: 'block' }}>事故号后六位{subReportId}，人伤姓名{lossName}。</span>
                        <div style={{ display: 'flex', marginTop: '24px', justifyContent: 'center' }}>
                            <Button onClick={() => notification.destroy()} style={{ marginRight: '24px' }}>稍后处理</Button>
                            {
                                getState().app.customers.current.length == 0 && <Button onClick={() => dispatch(EventBus.emit('push', `/medicalAdjustment?flowId=${flowId}&key=${timeStamp}&activeKey=${1}`), notification.destroy())} type="primary">立即处理</Button>
                            }


                        </div>
                    </div>
                ),
                placement: 'bottomRight'
            });
        }
    });
}

// 医疗理算图片上传通知
const uploadAdjustPicFinish = (dispatch, getState, report) => {
    socket.on('uploadAdjustPicFinish', data => {
        const { flowId, agentId } = data;
        const userInfo = getState().app.currentAgent.userInfo;
        // let url = document.querySelector('#medical-adjustment').src;
        // let arrObj = url.split('?');
        // let params = Object.create(null);
        // if (arrObj.length > 1) {
        //     arrObj = arrObj[1].split('&');
        //     arrObj.forEach(item => {
        //         item = item.split('=');
        //         params[item[0]] = item[1];
        //     });
        // }

        if (agentId == (userInfo && userInfo._id)) {
            const timeStamp = new Date().getTime();
            // dispatch(push(`/medicalAdjustment?flowId=${flowId}&key=${timeStamp}&activeKey=${2}`));
            dispatch(EventBus.emit('push', `/medicalAdjustment?flowId=${flowId}&key=${timeStamp}&activeKey=${2}`));
        }
    });
}

// 医疗理算票据识别结果通知
const ocrAdjustPicFinish = (dispatch, getState, report) => {
    socket.on('ocrAdjustPicFinish', data => {
        const { flowId, agent, subReportId } = data;
        const userInfo = getState().app.currentAgent.userInfo;

        if (agent == (userInfo && userInfo._id)) {
            notification['info']({
                message: '票据识别结果通知！',
                description: (
                    <div>
                        <span style={{ display: 'block' }}>任务尾号{subReportId}有新的识别结果</span>
                    </div>
                ),
                placement: 'bottomRight'
            });

            // const timeStamp = new Date().getTime();
            // dispatch(push(`/medicalAdjustment?flowId=${flowId}&key=${timeStamp}&activeKey=${3}`));
        }
    });
}

let smallProgram_dropConnect_client = (getState) => {

    socket.on('SPdropConnection', data => {

        let currentCustomer = getState().app.customers.current
        if (currentCustomer && currentCustomer.length > 0 && currentCustomer[0] == data.requestId) {
            message.warning('小程序连接已断开')
        }

    })
}

let receiveEvaluationMessage = (getState, dispatch) => {
    socket.on('showEvaluation', data => {
        let customer = getState().app.customers.current
        if (customer && customer.length > 0 && data.requestId == customer[0]._id) {

            let flowId
            try { flowId = getState().lossAss.reportPreview.currentPreviewReport.flowId } catch (e) { }
            dispatch(report.showEvaluation(data.evaluation, flowId))
        }
    })
}

let receiveTxfitMsg = (dispatch, getState) => {

    socket.on('receiveTxfitUrl', data => {
        let customer = getState().app.customers.current
        if (customer && customer.length > 0 && data.srid == customer[0]._id) {

            let wxSmallProgramRequest = getState().lossAss.wxSmallProgramRequest
            if (wxSmallProgramRequest.wxProgramPushUrl.length == 0) {
                dispatch(wxSmallProgramRequestAction.receiveTxfitUrl(data));
            }
        }
    });

    socket.on('receiveTxfitCustomMsg', data => {

        let obj = JSON.parse(data.msg)
        let customer = getState().app.customers.current
        if (customer && customer.length > 0 && obj.requestId == customer[0]._id) {
            if (obj.subType == 'showEvaluation') {

                dispatch(report.showEvaluation(obj.evaluation))
            } else if (obj.subType == 'lossOptionState') {
                if (getState().app.currentAgent.userInfo) {
                    // if(obj.lossOptionState.state == 'agree') {
                    //     Modal.success({
                    //         title: '用户已同意定损金额',
                    //     });
                    // }

                    if (obj.lossOptionState.state != 'agree') {
                        Modal.error({
                            title: '用户不同意定损金额，请重新协商',
                            onOk() {
                                window.postMessage({ security: true, eventName: 'hideModal' }, '*')
                            },

                        });
                    }
                }

                dispatch(reportPreviewActions.getLatestReport(customer[0].userInfo.flowId));
            } else if (obj.subType == 'wxStartPush') {
                if (!getState().lossAss.wxSmallProgramRequest.sendedTxfitUrlToBackgroud) {

                    let playurl = getState().lossAss.wxSmallProgramRequest.getFetchLivePlayResult;
                    let sendurl = getState().lossAss.wxSmallProgramRequest.wxProgramPushUrl;
                    let msg = {
                        cmd: 'invoke',
                        code: 'sendAddStreamToBackground({"address":"' + sendurl + '", "playaddress":"' + playurl + '"})'
                    }

                    window.postMessage(msg, '*')
                    dispatch(wxSmallProgramRequestAction.sendedTxfitUrlToBackgroud());
                }
            } else {
                console.error('unknown custom message')
            }
        }
    })


    socket.on('receiveTxfitWxInterrupt', data => {

        let customer = getState().app.customers.current[0]
        if (customer && data.srid == customer._id) {
            message.warning('对端小程序已挂断');
            window.postMessage({ cmd: 'invoke', code: 'sendRemoveStreamToBackground()' }, '*');
            dispatch(serviceRequestPiccActions.endSessionByPicc(customer._id))
        }
    })

    socket.on('receiveTxfitWxLeft', data => {

        let customer = getState().app.customers.current[0]
        if (customer && data.srid == customer._id) {
        }
    })
}

const deflossConfirmMsg = (dispatch, appState, getState) => {
    let { currentAgent } = appState.app || {};
    let { userInfo } = currentAgent || {};
    let reportPreview = appState.lossAss.reportPreview
    socket.on('deflossConfirmMsg', data => {
        if (userInfo && data.agentId === userInfo._id) {
            let msgKey = 'deflossConfirmMsg_' + +new Date();
            // notification.open({
            //     message: '定损信息确认',
            //     description: `受理号${data.flowId || ''},用户${data.isConfirmed == 2? '同意': '不同意'}损失确认书！`,
            //     icon: data.isConfirmed == 2 ? <Icon type="check" style={{ color: '#52C41A' }} /> :
            //             <Icon type="close" style={{ color: '#FF0000' }} />,
            //     placement: 'bottomRight',
            //     key: msgKey
            // });
            dispatch(reportPreviewActions.getCurrentReport(data.flowId));
        }
    });
}
let leaveMsgNotice = (dispatch, appState) => {
    let { currentAgent } = appState.app || {};
    let { userInfo } = currentAgent || {};
    socket.on('receivedMessageFromBusiness', data => {
        if (userInfo && data.agentId === userInfo._id) {
            let leaveMsgKey = 'leaveMsg_' + new Date().getTime();
            let props = {
                flowId: data.report.flowId,
                notificationKey: leaveMsgKey,
                newMsg: data.newMsg,
                actions: bindActionCreators(Object.assign({},
                    reportPreviewActions
                ), dispatch)
            }
            notification.open({
                message: '消息提示',
                description: <LeaveMsg {...props} />,
                placement: 'bottomRight',
                key: leaveMsgKey
                /*                duration:null*/
            });
        }
    })
}


let isInArray = (arr1, arr2) => {
    if (!(arr1 instanceof Array) || !(arr2 instanceof Array)) {
        return false;
    }
    let str1 = arr1.toString();
    let str2 = arr2.toString();
    if (str2.indexOf(str1) == -1) {
        return false;
    } else {
        return true;
    }
}


const getDeflossInfoSuccess = (dispatch, getState) => {
    let { userInfo } = getState().app.currentAgent || {};
    socket.on('getDeflossInfoSuccess', data => {
        if (userInfo && data.agentId === userInfo._id) {
            dispatch(reportPreviewActions.getCurrentReport(data.flowId))
        }
    })
};

const refreshReportDetail = (dispatch, getState) => {
    let { userInfo } = getState().app.currentAgent || {};
    socket.on('refreshReportDetail', data => {

        if (userInfo && data.agentId === userInfo._id) {
            dispatch(reportPreviewActions.getCurrentReport(data.flowId))
        }
    })
};

const packageCrowdDataDone = (dispatch, getState) => {

    socket.on('packageCrowdDataDone', scoketMessage => {



        const medicalAdjustment = document.getElementById("medical-adjustment").contentWindow

        medicalAdjustment.postMessage({ ...scoketMessage, security: true, eventName: 'packageCrowdDataDone' }, '*')

    })
};



const pushTipsToAgent = (dispatch, getState) => {
    socket.on('pushTipsToAgent', socketMessage => {
        const currentAgentId = getState().app.currentAgent.userInfo._id;
        if (currentAgentId === socketMessage.agentId) {
            const { report = {} } = socketMessage;
            if (getState().lossAss &&
                getState().lossAss.reportPreview &&
                (
                    getState().lossAss.reportPreview.currentPreviewReport &&
                    getState().lossAss.reportPreview.currentPreviewReport.flowId === socketMessage.flowId
                )
            ) {
                dispatch(reportPreviewActions.getCurrentReport(socketMessage.flowId))
            }

            const close = () => {
                // 跳转到我的任务工单详情，场景1，案件处理人；场景2，案件定损中且是案件定损员；其他情况下均跳转到业务中心的工单详情
                if (report.agentId === currentAgentId || (report.defLossAgentId === currentAgentId && report.defLossState === 'checking')) {
                    dispatch(EventBus.emit('push', `/workBench/ReportDetail/${socketMessage.flowId}`));
                } else {
                    dispatch(EventBus.emit('push', `/customerCenter/ReportDetail/${socketMessage.flowId}`));
                    dispatch(reportPreviewActions.getCreateReport('update'))
                    dispatch(reportPreviewActions.changeActiveReportTab('1'))
                    dispatch(reportPreviewActions.getCurrentReport(socketMessage.flowId))
                }
            };
            const key = `open${Date.now()}`;
            const btn = (
                <Button type="primary" size="small" onClick={() => close(key)}>
                    查看详情
                </Button>
            );
            notification.open({
                message: `${socketMessage.content}`,
                description: '',
                btn,
                key,
                // onClose: close,
                onClose: notification.close(key),
                placement: 'bottomRight'
            });
        }

    })

}

const pushCoopTaskTipsToAgent = (dispatch, getState) => {
    socket.on('pushCoopTaskTipsToAgent', socketMessage => {
        const currentAgentId = getState().app.currentAgent.userInfo._id;
        if (currentAgentId === socketMessage.agentId) {
            const { report = {} } = socketMessage;
            window.postMessage({ ...socketMessage, security: true, eventName: 'pushCoopTaskTipsToAgent' }, '*')
            const close = () => {
                // 跳转到我的任务工单详情，场景一，案件处理人；场景二，案件定损中且是案件定损员；其他情况下均跳转到业务中心的工单详情
                if (report.agentId === currentAgentId || (report.defLossAgentId === currentAgentId && report.defLossState === 'checking')) {
                    dispatch(EventBus.emit('push', `/workBench/ReportDetail/${socketMessage.flowId}`));
                } else {
                    dispatch(EventBus.emit('push', `/customerCenter/ReportDetail/${socketMessage.flowId}`));
                    dispatch(reportPreviewActions.getCreateReport('update'))
                    dispatch(reportPreviewActions.changeActiveReportTab('1'))
                    dispatch(reportPreviewActions.getCurrentReport(socketMessage.flowId))
                }
            };
            const key = `open${Date.now()}`;
            const btn = (
                <Button type="primary" size="small" onClick={() => close(key)}>
                    查看详情
                </Button>
            );
            notification.open({
                message: `${socketMessage.content}`,
                description: '',
                btn,
                key,
                // onClose: close,
                onClose: notification.close(key),
                placement: 'bottomRight'
            });

        }

    })

}

const agentGotNewMsg = (dispatch, getState) => {
    socket.on('agentGotNewMsg', scoketMessage => {

        if (getState().app.currentAgent.userInfo._id === scoketMessage.agentId) {
            dispatch(serviceRequestActions.updateMsgBoard({
                agentGotNewMsg: true
            }))
            window.postMessage({ security: true, eventName: 'refreshChatRecord', scoketMessage }, '*')
        }

    })
};
//刷新我的任务列表
const refreshMyTaskList = (dispatch, getState) => {
    socket.on('refreshMyTaskList', scoketMessage => {

        if (getState().app.currentAgent.userInfo._id === scoketMessage.agentId) {

            window.postMessage({ security: true, eventName: 'refreshMyTaskList', scoketMessage }, '*')
        }

    })
};






//刷新音视频列表
const trtcVideoCapture = (dispatch, getState) => {
    socket.on('trtcVideoCapture', scoketMessage => {

        if (getState().app.currentAgent.userInfo._id === scoketMessage.agentId) {

            window.postMessage({ security: true, eventName: 'trtcVideoCapture', scoketMessage }, '*')
        }

    })
};


//更新图片状态
const AgentLocalUploadPic = (dispatch, getState) => {
    /**
     * flowId
     * status
     * uid
     * type
     */
    socket.on('Agent:LocalUploadPic', socketMessage => {
        if (getState().app.currentAgent.userInfo._id === socketMessage.agentId) {
            console.log('Agent:LocalUploadPic', socketMessage)
            const { type, status, uid} = socketMessage;
            switch(type) {
                case 'parcelManage':
                    dispatch(uploadAction.getChangeUploadStatusAction({
                        asyncStatus: status,
                        uid
                    }))
                    break;
                default: 
                    const queue = window.fileListQueue;
                    if (!queue) {
                        return
                    }
                    const newFileList = queue.getList();
                    if (!newFileList) {
                        return
                    }
        
                    let curIndex = newFileList.findIndex(item => item.file.uid === socketMessage.uid);
                    if (curIndex < 0) {
                        return
                    }
                    // let curData = newFileList[curIndex];
                    // curData.asyncStatus = socketMessage.status;
                    queue.update(curIndex, {
                        ...newFileList[curIndex],
                        asyncStatus: socketMessage.status,
                        failureReason: ['error', 'fail'].includes(socketMessage.status)
                            ? socketMessage.errorMessage || '图片处理或云存储上传失败，请稍后重试'
                            : '',
                    })
                    const newList = queue.getList();
                    // console.log('修改后的数组', newList)
                    // window.newFileList = newFileList
        
        
                    notification.open({
                        top: 100,
                        key: 'upload-list',
                        message: <>
                            <span style={{ fontWeight: 'blod' }}> 任务上传中</span>
                            <Spin size='small' style={{ marginLeft: 10 }} />
                            <span style={{ color: '#ccc', marginLeft: 10 }}>成功{newList.filter((file) => file.asyncStatus === 'success').length}</span>
                            <span style={{ color: '#ccc', marginLeft: 10 }}>失败{newList.filter((file) => file.asyncStatus === 'error' || file.asyncStatus === 'fail').length}</span>
                            <span style={{ color: '#ccc', marginLeft: 10 }}>上传中{newList.filter((file) => file.asyncStatus === 'uploading' || file.asyncStatus === '').length}</span>
                        </>,
                        duration: 0,
                        description:
                            <UploadList data={newList} />,
                        onClick: () => {
                            console.log('Notification Clicked!');
                        },
                    });
        
        
                    // 判断图片全部上传结束
                    if (newList.filter((file) => (file.asyncStatus === 'uploading' || file.asyncStatus === '')).length === 0) {
                        console.log('全部上传完成')
        
                        // 更新图片列表
                        window.postMessage({ security: true, eventName: 'refreshPicsClassify', flowId: socketMessage.flowId }, '*')
        
                        const failList = newList.filter((file) => file.asyncStatus === 'error' || file.asyncStatus === 'fail')
                        const successCount = newList.filter((file) => file.asyncStatus === 'success').length
                        notification.open({
                            top: 100,
                            key: 'upload-list',
                            message: <>
                            </>,
                            duration: failList.length === 0 ? 3 : 0,
                            description:
                                <UploadList successCount={successCount} status='finish' data={failList} />,
                            onClick: () => {
                                console.log('Notification Clicked!');
                            },
                        });
        
        
                    }
            }
           


        }

    })
};

//邮寄统计数量变更通知
const ExpressMaterialStatUpdate = (dispatch, getState) => {
    socket.on('Agent:ExpressMaterialStatUpdate', socketMessage => {
        console.log('Agent:ExpressMaterialStatUpdate', socketMessage)
            window.postMessage({ security: true, eventName: 'ExpressMaterialStatUpdate', ...socketMessage }, '*')
    })
};


// 客服会话记录下载
const CallRecordVoiceDownload = (dispatch, getState) => {
    socket.on('Agent:callRecordVoiceDownload', socketMessage => {
        if (getState().app.currentAgent.userInfo._id === socketMessage.agentId) {
            window.postMessage({ security: true, eventName: 'CallRecordVoiceDownloadUpdate', ...socketMessage }, '*')
        }
    })
}

/**
 * 视频理赔（新版）：客户发起视频呼叫 → 推送呼入弹窗给坐席。
 * socketMessage = {
 *   agentId, sessionId, flowId,
 *   inviteeType, inviteeName, inviteePhone,
 *   callingTimeoutMs,
 * }
 */
const videoClaimIncoming = (dispatch, getState) => {
    socket.on('videoClaim:calling', socketMessage => {
        const agent = getState().app.currentAgent.userInfo;
        if (!agent || !socketMessage || agent._id !== socketMessage.agentId) return;
        window.postMessage(
            { security: true, eventName: 'VideoClaimIncoming', socketMessage },
            '*'
        );
    });
    // 呼入结束（接听/拒接/超时/客户取消）→ 关闭呼入弹窗
    socket.on('videoClaim:callingClosed', socketMessage => {
        const agent = getState().app.currentAgent.userInfo;
        if (!agent || !socketMessage || agent._id !== socketMessage.agentId) return;
        window.postMessage(
            { security: true, eventName: 'VideoClaimIncomingClosed', socketMessage },
            '*'
        );
    });
};

export {
    deflossConfirmMsg,
    agentLoggedIn,
    agentReconnect,
    agentExpired,
    agentLoggedOut,
    agentConnected,
    agentDisconnected,
    agentKandyStatus,
    agentReconnectFailed,
    agentUnload,
    noticeUpdateLoginState,
    noticeUpdateServiceStatus,
    assignedAdjustReport,
    receiveEvaluationMessage,
    receiveTxfitMsg,
    receiveUploadCarPic_Client,
    uploadShotPicFinish,
    smallProgram_dropConnect_client,
    serviceRequestsUpdated,

    customerDisconnected,
    clientEndedSession,

    removeNotificationListener,
    messageEvent,

    leaveMsgNotice,
    getDeflossInfoSuccess,
    refreshReportDetail,
    uploadAdjustPicFinish,
    ocrAdjustPicFinish,
    packageCrowdDataDone,
    pushTipsToAgent,
    pushCoopTaskTipsToAgent,
    agentGotNewMsg,
    refreshMyTaskList,
    trtcVideoCapture,
    AgentLocalUploadPic,
    ExpressMaterialStatUpdate,
    CallRecordVoiceDownload,
    videoClaimIncoming,
}
;
